import {
  DisplayRecommendation,
  type HiddenPrice,
  type Money,
  type Price,
  type Tax,
} from 'src/graphql/generated';

type GetPremiumUpgradePriceParams = {
  baseProductId?: string;
  upsellProductId?: string;
  productSet?: {
    items: Array<{
      id: string;
      price: Price | HiddenPrice;
      __typename?: string;
    } | null>;
  } | null;
  hidePrice?: boolean | null;
};

export const getUpsellAndBaseProductPriceDifference = ({
  baseProductId,
  upsellProductId,
  productSet,
  hidePrice,
}: GetPremiumUpgradePriceParams): {
  price?: Money;
  tax?: Tax;
} => {
  const baseProductPrice = productSet?.items?.find(
    (item) => item?.id === baseProductId,
  )?.price;

  const upsellProductPrice = productSet?.items?.find(
    (item) => item?.id === upsellProductId,
  )?.price;

  if (
    hidePrice ||
    baseProductPrice?.__typename !== 'Price' ||
    upsellProductPrice?.__typename !== 'Price' ||
    !baseProductPrice.netPrice.value ||
    !upsellProductPrice.netPrice.value ||
    !upsellProductPrice.tax ||
    !baseProductPrice.tax
  ) {
    return { tax: undefined, price: undefined };
  }

  const priceDifference =
    upsellProductPrice.netPrice.value - baseProductPrice.netPrice.value;

  const price = isFinite(priceDifference)
    ? {
        value: priceDifference,
        currency: upsellProductPrice.netPrice.currency,
      }
    : undefined;

  const tax =
    upsellProductPrice.tax.displayRecommendation ===
    DisplayRecommendation.exclusive
      ? upsellProductPrice.tax
      : {
          ...upsellProductPrice.tax,
          amount: {
            currency: upsellProductPrice.netPrice.currency,
            value:
              upsellProductPrice.tax.amount?.value -
              baseProductPrice.tax.amount?.value,
          },
        };

  return {
    price,
    tax,
  };
};
